import { GenerateNotificationsProps, Notification } from "./types";

export const generateNotifications = ({
  numberOfPendingLearners,
}: GenerateNotificationsProps): Notification[] => {
  const notifications: Notification[] = [];

  if (numberOfPendingLearners > 0) {
    notifications.push({
      id: "number-of-pending-learners",
      type: "APPROVE_LEARNER",
      count: numberOfPendingLearners,
    });
  }

  return notifications;
};
